import React from 'react';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function StudentResources() {
  return (
    <StaticPage title="Student Resources" subtitle="Useful links and information to help you settle into life in Australia.">
      <Section title="Visa & Immigration">
        <CardGrid items={[
          { title: 'Student Visa (Subclass 500)', desc: 'Apply and manage your student visa through the Australian Department of Home Affairs website.' },
          { title: 'Working Rights', desc: 'Most student visas allow you to work up to 48 hours per fortnight during study periods.' },
          { title: 'OSHC Insurance', desc: 'Overseas Student Health Cover is mandatory. Compare providers at privatehealth.gov.au.' },
          { title: 'Tax File Number (TFN)', desc: 'Apply for your TFN through the ATO before starting work in Australia.' },
        ]} />
      </Section>

      <Section title="Banking & Finance">
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Commonwealth Bank Student Account</strong> — No monthly fee for students</li>
          <li><strong>ANZ Progress Saver</strong> — Good for saving your bond/deposit</li>
          <li><strong>Wise (TransferWise)</strong> — Best for receiving money from overseas</li>
          <li><strong>Centrelink</strong> — Check if you're eligible for any government support payments</li>
        </ul>
      </Section>

      <Section title="Healthcare">
        <ul className="list-disc list-inside space-y-2">
          <li>All international students must have OSHC — check your policy covers GP visits</li>
          <li>University health centres offer free or low-cost GP consultations</li>
          <li>Medicare — available for students from countries with a Reciprocal Health Care Agreement</li>
          <li>Mental health support: Beyond Blue (1300 22 4636), Lifeline (13 11 14)</li>
        </ul>
      </Section>

      <Section title="Student Associations & Communities">
        <CardGrid items={[
          { title: 'Study Melbourne', desc: 'The Victorian Government\'s official hub for international students — events, advice, and a free welcome program.' },
          { title: 'Study NSW', desc: 'Information and support for international students studying in New South Wales.' },
          { title: 'International Student Support', desc: 'Every university has a dedicated international student office — your first stop for any issue.' },
          { title: 'Meetup & Facebook Groups', desc: 'Search "[Your City] International Students" on Facebook — great way to find flatmates and make friends.' },
        ]} />
      </Section>
    </StaticPage>
  );
}
